<gd-dialog-container (close)="closeModal()">
  <div class="header">
    <h2 class="modal-title">{{ dialogData.title | translate }}</h2>
  </div>
  <div class="content">
    <h4 class="modal-sub-title">{{ dialogData.subtitle | translate }}</h4>

    <gd-e-commerce-store-list [storesList]="storesList" (storeSelect)="selectStore($event)"></gd-e-commerce-store-list>
  </div>
</gd-dialog-container>
